// tslint:disable:2531
import React, { useState, useEffect, useRef, InputHTMLAttributes, memo } from 'react';

import Text from './Text';

interface FilePickerProps extends InputHTMLAttributes<HTMLElement> {
  value: any,
  onChange: any,
  label: string,
}

function FilePicker({
  value, onChange, label,
  ...rest
}: FilePickerProps) {
  const [state, setState] = useState(null);
  const fileInput = useRef(null);

  useEffect(() => {
    if (value) setState(value);
  }, [value]);

  const handleChange = (file: any) => {
    console.log(file.target.files[0]);
    if (onChange) onChange(file.target.files ? file.target.files[0] : null);
  };

  console.log(state);

  return (
    <div className="component-file-picker">
      <Text level="label">
        { label }
      </Text>
      <div className="input-container">
        <div>
          { state && state.name }
        </div>
        <button type="button" onClick={() => {
          // @ts-ignore
          fileInput.current.click()
        }}>
          SELECCIONAR
        </button>
      </div>
      <input
        {...rest}
        ref={fileInput}
        type="file"
        onChange={file => handleChange(file)}
      />
    </div>
  );
}

export default memo(FilePicker);

FilePicker.defaultProps = {
  value: null,
  onChange: null,
  label: null,
};
